import React, {Component} from "react";
import {
    Button,
    FormField,
    FormSection,
    Input,
    InputLabel,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import {GeneLifeDict} from "../translate/GeneLife"
import '../Styles/genelife.css';
import '../Styles/subpages.css';

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export class CheckEccAccountComponents extends Component {
    render() {
        return (
            <div>
            <Header/>
              <div className="content_wrapper">
                <h2 className="title_content" theme={this.props.theme}>{I18n.get("Confirm registered Email")}</h2>
                <div className="area_usual">
                    <div className="container">
            <FormSection theme={this.props.theme}>

            <SectionBody theme={this.props.theme}>
                <FormField theme={this.props.theme} key="nickname">
                  <p className="inbox-notice">登録メールアドレスの確認および変更は、<br />2019年4月24日以前にGeneLifeの会員になった方が対象となります。</p>
                    <InputLabel theme={this.props.theme}>{I18n.get("Nickname")}</InputLabel>
                    <Input
                        // placeholder={I18n.get("ログインID")}
                        theme={this.props.theme}
                        name="nickname"
                        key="nickname"
                        onChange={this.props.checkEccAccount.handleInputChange}
                    />
                </FormField>
                <FormField theme={this.props.theme} key="email">
                    <InputLabel theme={this.props.theme}>{I18n.get("Password")}</InputLabel>
                    <Input
                        // placeholder={I18n.get("Passward")}
                        theme={this.props.theme}
                        key="password"
                        name="password"
                        type="password"
                        onChange={this.props.checkEccAccount.handleInputChange}
                    />
                </FormField>
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button onClick={this.props.checkAccountInEcc} theme={this.props.theme}>
                        {I18n.get("Check Account")}
                    </Button>
                </SectionFooterPrimaryContent>

                {
                  <SectionFooterSecondaryContent theme={this.props.theme}>

                    <Link theme={this.props.theme} style={STYLE_LINK} onClick={this.props.changeStateFunc}>
                        {I18n.get("Back to Sign In")}
                    </Link>
                </SectionFooterSecondaryContent>
              }

            </SectionFooter>
        </FormSection>
        </div>
        </div>
        </div>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

CheckEccAccountComponents.propTypes = {
    theme: PropTypes.any,
    checkEccAccount: PropTypes.any,
    checkAccountInEcc: PropTypes.func,
    changeStateFunc: PropTypes.func
};
